import React from "react";
import TaxesDetail from "./TaxesDetail";
import "../../../Styles/TaxesWorkspace.css";

const MainTaxes = () => {
  return <TaxesDetail />;
};

export default MainTaxes;
